export class WhitelistsApiService {
	constructor(CoreApi) {
		this.CoreApi = CoreApi;
	}
	list(params) {
		return this.CoreApi.makeApiCall("POST", "whitelists/list/", params).then(r => r.data);
	}
	delete(numbers) {
		return this.CoreApi.makeApiCall("POST", "whitelists/delete/", null, {numbers: JSON.stringify(numbers)}).then(r => r);
	}
	create(data) {
		return this.CoreApi.makeApiCall("POST", "whitelists/save/", data).then(r => r);
	}
	import(rows) {
		return this.CoreApi.makeApiCall("POST", "whitelists/import/", null, {data: JSON.stringify(rows)}).then(r => r);
	}
}